import { createAction } from "@actions/actionCreators";

const [useDownloadFile, downloadFile] = createAction<string>("downloadFile");

export default useDownloadFile;
export { downloadFile };
